import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {
    TextField,
    Button,
    MenuItem,
    Select,
    FormControl,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow, TableCell, TableBody, IconButton, DialogTitle, DialogContent, Dialog, DialogActions
} from '@mui/material';
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import "./DictionaryTypeAdder.css"

const DictionaryTypeAdder = ({onAdd}) => {
    const [name, setName] = useState('');
    const [isAddModalOpen, setAddModalOpen] = useState(false);
    const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
    const [addAlert, setAddAlert] = useState({show: false, message: '', type: ''});
    const [deleteAlert, setDeleteAlert] = useState({show: false, message: '', type: ''});
    const [dictionaryTypes, setDictionaryTypes] = useState([]);
    const [selectedId, setSelectedId] = useState(null);
    const [dropdownData, setDropdownData] = useState({});
    const [selectedType, setSelectedType] = useState('');
    const [isNewDataModalOpen, setNewDataModalOpen] = useState(false);
    const [newDictionaryName, setNewDictionaryName] = useState('');
    const [confirmDeleteModalOpen, setConfirmDeleteModalOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [selectOpen, setSelectOpen] = useState(false);
    const [isEditModalOpen, setEditModalOpen] = useState(false);
    const [editName, setEditName] = useState('');
    const [isEditConfirmModalOpen, setEditConfirmModalOpen] = useState(false);
    const [editAlert, setEditAlert] = useState({show: false, message: '', type: ''});

    const handleEditConfirm = async () => {
        try {
            const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditDictionaryTypesName`, {
                id: selectedId,
                name: editName
            });
            if (response.data.success) {
                fetchData();
                setEditConfirmModalOpen(false);
                setEditModalOpen(false);
                setEditAlert({show: true, message: 'ოპერაცია წარმატებით დასრულდა', type: 'success'}); // Show success alert

            } else {
                setEditAlert({show: true, message: 'დაფიქსირდა შეცდომა', type: 'error'}); // Show error alert

            }
        } catch (error) {
            setEditAlert({show: true, message: 'დაფიქსირდა შეცდომა', type: 'error'}); // Show error alert

        }
    };
    const closeEditAlert = () => {
        setEditAlert({...editAlert, show: false});
    };

    const openEditModal = (id, name) => {
        setEditName(name); // Set the name in the modal
        setSelectedId(id); // Assuming setSelectedId is used to store the ID of the item to edit
        setEditModalOpen(true);
    };
    const openConfirmDeleteModal = (id) => {
        setItemToDelete(id);
        setConfirmDeleteModalOpen(true);
    }

    const closeConfirmDeleteModal = () => {
        setConfirmDeleteModalOpen(false);
        setItemToDelete(null);
    };

    const handleTypeChange = (event) => {
        setSelectedType(event.target.value);
    };

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const typesResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryTypes`);
            if (typesResponse.data && typesResponse.data.success) {
                setDictionaryTypes(typesResponse.data.data);

                const promises = typesResponse.data.data.map(type =>
                    axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionary?DictionaryTypeId=${type.id}`)
                );
                const results = await Promise.all(promises);
                const newData = results.reduce((acc, result, index) => {
                    if (result.data && result.data.success) {
                        acc[typesResponse.data.data[index].id] = result.data.data;
                    }
                    return acc;
                }, {}); 
                setDropdownData(newData);


            }
        } catch (error) {
        }  
    };

    const handleNameChange = (event) => {
        setName(event.target.value);
    };

    const openAddModal = () => {
        if (!name.trim()) {
            return;
        }
        setAddModalOpen(true);
    };

    const openDeleteModal = (id) => {
        setSelectedId(id);
        setDeleteModalOpen(true);
    };

    const closeAddModal = () => {
        setAddModalOpen(false);
    };

    const closeDeleteModal = () => {
        setDeleteModalOpen(false);
        setSelectedId(null);
    };

    const handleAdd = async () => {
        setAddModalOpen(false);
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewDictionaryTypes`, {name});
            setName('');
            setAddAlert({show: true, message: 'ოპერაცია წარმატებით დასრულდა!', type: 'success'});
            void fetchData();
            onAdd()
        } catch (error) {
            setAddAlert({show: true, message: 'დაფიქსირდა შეცდომა!', type: 'error'});
        }
    };
    const openDeleteModalWithId = (id, event) => {
        event.stopPropagation(); // Prevents the dropdown from changing its value when clicking the delete button
        openDeleteModal(id);
        setSelectOpen(false); // Close the Select dropdown
    };
    const handleDelete = async () => {
        setDeleteModalOpen(false);
        try {
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/DeleteDictionaryTypes`, {id: selectedId});
            setDeleteAlert({show: true, message: 'ტიპი წაიშალა წარმატებით!', type: 'success'});
            fetchData();
        } catch (error) {
            setDeleteAlert({show: true, message: 'წაშლისას დაფიქსირდა შეცდომა!', type: 'error'});
        } finally {
            setSelectedId(null);
        }
    };

    const closeAddAlert = () => {
        setAddAlert({...addAlert, show: false});
    };
    const handleDeleteTableElem = async (id) => {
        setConfirmDeleteModalOpen(false);
        try {
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/DeleteDictionary`, {id});
            setDeleteAlert({show: true, message: 'ოპერაცია წარმატებით დასრულდა!', type: 'success'});
            fetchData(); // Refresh the data
        } catch (error) {
            setDeleteAlert({show: true, message: 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით', type: 'error'});
        }
    };

    const closeDeleteAlert = () => {
        setDeleteAlert({...deleteAlert, show: false});
    };
    const handleNewDictionaryNameChange = (event) => {
        setNewDictionaryName(event.target.value);
    };

    const handleAddNewDropdownData = async () => {
        setNewDataModalOpen(false);
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewDictionary`, {
                dictionaryTypeId: selectedType,
                dictionaryname: newDictionaryName,
                dictionaryId: null
            });
            setNewDictionaryName('');
            fetchData();
        } catch (error) {
        }
    };


    const handleSelectOpen = () => {
        setSelectOpen(!selectOpen);
    };


    return (
        <div className={""} style={{paddingLeft: 150, paddingRight: 150}}>
            <div className={"dicntonary-adder"}>
                <div style={{marginBottom: "20px"}}>
                    <h1 className="employee-form-title">ცნობარის დამატება</h1>
                    <div style={{display: "flex", gap: 20, marginBottom: "20px"}}>

                        <TextField
                            label="ცნობარის სახელი"
                            variant="outlined"
                            value={name}
                            onChange={handleNameChange}
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={openAddModal}
                            disabled={!name.trim()}
                        >
                            დამატება
                        </Button>
                    </div>
                </div>
            </div>

            <FormControl fullWidth margin="normal">
                <Select
                    open={selectOpen}
                    onOpen={handleSelectOpen}
                    onClose={handleSelectOpen}
                    value={selectedType}
                    onChange={handleTypeChange}
                    displayEmpty
                    renderValue={selected => {
                        if (selected === "") {
                            return <em>აირჩიეთ ცნობარი</em>;
                        }
                        const selectedItem = dictionaryTypes.find(type => type.id === selected);
                        return selectedItem ? selectedItem.typesName : 'Select Dictionary Type';
                    }}
                >
                    <MenuItem value="" disabled>აირჩიეთ ცნობარი</MenuItem>
                    {dictionaryTypes.map((type) => (
                        <MenuItem key={type.id} value={type.id}
                                  style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                            <span>{type.typesName}</span>
                            <span>

                          <Button
                              onClick={() => openEditModal(type.id, type.typesName)}
                              size="small"
                              edge="end"
                              aria-label="edit"
                              variant="contained"
                              color="primary"
                          >
                            სახელის შეცვლა
                          </Button>
                                <Button
                                    onClick={(event) => openDeleteModalWithId(type.id, event)}
                                    size="small"
                                    edge="end"
                                    aria-label="delete"
                                    variant="contained"
                                    color="error"
                                    style={{marginLeft: 10}}
                                >
                                წაშლა
                            </Button>
                            </span>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>


            {selectedType && (

                <div>
                    <div></div>
                    <h1 className="employee-form-title">ელემეტის დამატება</h1>

                    <div style={{display: "flex", gap: 20, marginBottom: "20px", paddingLeft: 50, paddingRight: 50}}>

                        <TextField
                            autoFocus
                            margin="dense"
                            label="ელემენტის სახელი"
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={newDictionaryName}
                            onChange={handleNewDictionaryNameChange}
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setNewDataModalOpen(true)}
                        >
                            დამატება
                        </Button>
                    </div>
                    <TableContainer component={Paper} style={{maxHeight: 600, overflow: 'auto'}}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>ID</TableCell>
                                    <TableCell>ელემენტი</TableCell>
                                    <TableCell>ქმედება</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dropdownData[selectedType]?.map((item) => (
                                    <TableRow key={item.id}>
                                        <TableCell component="th" scope="row">{item.id}</TableCell>
                                        <TableCell>{item.typesName}</TableCell>
                                        <TableCell>
                                            <Button
                                                onClick={() => openConfirmDeleteModal(item.id)}
                                                color="secondary"
                                                variant="contained"

                                            >
                                                წაშლა
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Dialog style={{zIndex: 43}} open={isEditModalOpen} onClose={() => setEditModalOpen(false)}>
                        <DialogContent>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="name"
                                label="ცნობარის სახელი"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={editName}
                                onChange={(e) => setEditName(e.target.value)}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setEditModalOpen(false)}>გაუქმება</Button>
                            <Button onClick={() => setEditConfirmModalOpen(true)}>შენახვა</Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {isAddModalOpen && (
                <ConfirmationModal
                    isOpen={isAddModalOpen}
                    onRequestClose={closeAddModal}
                    onConfirm={handleAdd}
                />
            )}

            {addAlert.show && (
                <CustomAlert
                    message={addAlert.message}
                    type={addAlert.type}
                    onClose={closeAddAlert}
                />
            )}
            {isNewDataModalOpen && (
                <ConfirmationModal
                    isOpen={isNewDataModalOpen}
                    onRequestClose={() => setNewDataModalOpen(false)}
                    onConfirm={handleAddNewDropdownData}
                    title="Add New Dictionary Data" // Add a title if your modal supports it
                >

                </ConfirmationModal>
            )}

            {isDeleteModalOpen && (
                <ConfirmationModal
                    isOpen={isDeleteModalOpen}
                    onRequestClose={closeDeleteModal}
                    onConfirm={handleDelete}
                />
            )}

            {deleteAlert.show && (
                <CustomAlert
                    message={deleteAlert.message}
                    type={deleteAlert.type}
                    onClose={closeDeleteAlert}
                />
            )}
            {confirmDeleteModalOpen && (
                <ConfirmationModal
                    isOpen={confirmDeleteModalOpen}
                    onRequestClose={closeConfirmDeleteModal}
                    onConfirm={() => handleDeleteTableElem(itemToDelete)}
                >
                </ConfirmationModal>
            )}
            {isEditConfirmModalOpen && (
                <ConfirmationModal
                    isOpen={isEditConfirmModalOpen}
                    onRequestClose={() => setEditConfirmModalOpen(false)}
                    onConfirm={handleEditConfirm}
                >
                </ConfirmationModal>
            )}
            {editAlert.show && (
                <CustomAlert
                    message={editAlert.message}
                    type={editAlert.type}
                    onClose={closeEditAlert}
                />
            )}
        </div>
    );
};

export default DictionaryTypeAdder;